import { DataBean } from "../DataBean";

export class AnualEvents extends DataBean {
  public async getAnualEventsCatalogPorPropiedades(
    properties: any,
    maxRows: number
  ): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "java.util.List_getAnualEventsCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getFestiveDayRender(year: number, month: number): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "java.util.List_getFestiveDayRender_Number_Number",
      [year, month]
    );
  }

  public async deleteAnualEvents(idanualevents: number): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "boolean_deleteAnualEvents_Number",
      [idanualevents]
    );
  }

  public async updateAnualEvents(bean: any): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "com.orange.people.talent.bean.AnualEvents_updateAnualEvents_com.orange.people.talent.bean.AnualEvents",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.people.talent.bean.AnualEvents",
        },
      ]
    );
  }
}
